// extracted by mini-css-extract-plugin
module.exports = {"campsite-key-figures":"style_campsite-key-figures__1Nx94"};